import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { createApp } from 'app'

console.log('Starting up');
const root = document.getElementById('root')

const { App } = createApp()
ReactDOM.render(<App />, root)
